import { api } from '../api';

/**
 * Reenvia o convite de boas-vindas do paciente (tarefa 0.33).
 *
 * O convite vale 7 dias, e sem reenvio a única saída de quem perde a janela seria o OTP
 * por SMS do aplicativo — que depende de o telefone estar certo no cadastro, e telefone é
 * opcional.
 *
 * Escopo `register_patient`, e o paciente tem de estar no escopo de quem chama. Responde
 * 400 quando o titular já criou a senha dele (aí o caminho é a recuperação de senha, que
 * ele mesmo inicia no aplicativo) ou quando não há e-mail no cadastro.
 *
 * ⚠️ Não é o `resendInvite` de `services/user`: aquele exige `register_user` — chave só do
 * administrador — e manda o template de usuário de equipe.
 */
export const resendPatientInvite = async (patientId: string): Promise<void> => {
  await api.post(`/patients/${patientId}/invite`);
};
